import { ReactComponent as Add } from "@svgr/webpack?-svgo,+titleProp,+ref!./Add.svg";
import { ReactComponent as Camera } from "@svgr/webpack?-svgo,+titleProp,+ref!./Camera.svg";
import { ReactComponent as Clipboard } from "@svgr/webpack?-svgo,+titleProp,+ref!./Clipboard.svg";
import { ReactComponent as Collapse } from "@svgr/webpack?-svgo,+titleProp,+ref!./Collapse.svg";
import { ReactComponent as Delete } from "@svgr/webpack?-svgo,+titleProp,+ref!./Delete.svg";
import { ReactComponent as Description } from "@svgr/webpack?-svgo,+titleProp,+ref!./Description.svg";
import { ReactComponent as Down } from "@svgr/webpack?-svgo,+titleProp,+ref!./Down.svg";
import { ReactComponent as Download } from "@svgr/webpack?-svgo,+titleProp,+ref!./Download.svg";
import { ReactComponent as Duplicate } from "@svgr/webpack?-svgo,+titleProp,+ref!./Duplicate.svg";
import { ReactComponent as Edit } from "@svgr/webpack?-svgo,+titleProp,+ref!./Edit.svg";
import { ReactComponent as Email } from "@svgr/webpack?-svgo,+titleProp,+ref!./Email.svg";
import { ReactComponent as Exit } from "@svgr/webpack?-svgo,+titleProp,+ref!./Exit.svg";
import { ReactComponent as Expand } from "@svgr/webpack?-svgo,+titleProp,+ref!./Expand.svg";
import { ReactComponent as Export } from "@svgr/webpack?-svgo,+titleProp,+ref!./Export.svg";
import { ReactComponent as Filter } from "@svgr/webpack?-svgo,+titleProp,+ref!./Filter.svg";
import { ReactComponent as Gallery } from "@svgr/webpack?-svgo,+titleProp,+ref!./Gallery.svg";
import { ReactComponent as Gear } from "@svgr/webpack?-svgo,+titleProp,+ref!./Gear.svg";
import { ReactComponent as Hide } from "@svgr/webpack?-svgo,+titleProp,+ref!./Hide.svg";
import { ReactComponent as Import } from "@svgr/webpack?-svgo,+titleProp,+ref!./Import.svg";
import { ReactComponent as Left } from "@svgr/webpack?-svgo,+titleProp,+ref!./Left.svg";
import { ReactComponent as Link } from "@svgr/webpack?-svgo,+titleProp,+ref!./Link.svg";
import { ReactComponent as Lock } from "@svgr/webpack?-svgo,+titleProp,+ref!./Lock.svg";
import { ReactComponent as Map } from "@svgr/webpack?-svgo,+titleProp,+ref!./Map.svg";
import { ReactComponent as Next } from "@svgr/webpack?-svgo,+titleProp,+ref!./Next.svg";
import { ReactComponent as Pencil } from "@svgr/webpack?-svgo,+titleProp,+ref!./Pencil.svg";
import { ReactComponent as Previous } from "@svgr/webpack?-svgo,+titleProp,+ref!./Previous.svg";
import { ReactComponent as Refresh } from "@svgr/webpack?-svgo,+titleProp,+ref!./Refresh.svg";
import { ReactComponent as Report } from "@svgr/webpack?-svgo,+titleProp,+ref!./Report.svg";
import { ReactComponent as Right } from "@svgr/webpack?-svgo,+titleProp,+ref!./Right.svg";
import { ReactComponent as Search } from "@svgr/webpack?-svgo,+titleProp,+ref!./Search.svg";
import { ReactComponent as Send } from "@svgr/webpack?-svgo,+titleProp,+ref!./Send.svg";
import { ReactComponent as Show } from "@svgr/webpack?-svgo,+titleProp,+ref!./Show.svg";
import { ReactComponent as Shuffle } from "@svgr/webpack?-svgo,+titleProp,+ref!./Shuffle.svg";
import { ReactComponent as Subtract } from "@svgr/webpack?-svgo,+titleProp,+ref!./Subtract.svg";
import { ReactComponent as Undo } from "@svgr/webpack?-svgo,+titleProp,+ref!./Undo.svg";
import { ReactComponent as Unlock } from "@svgr/webpack?-svgo,+titleProp,+ref!./Unlock.svg";
import { ReactComponent as Up } from "@svgr/webpack?-svgo,+titleProp,+ref!./Up.svg";
import { ReactComponent as Update } from "@svgr/webpack?-svgo,+titleProp,+ref!./Update.svg";
import { ReactComponent as Upload } from "@svgr/webpack?-svgo,+titleProp,+ref!./Upload.svg";
import { ReactComponent as Video } from "@svgr/webpack?-svgo,+titleProp,+ref!./Video.svg";
import { ReactComponent as DefaultPlayer } from "@svgr/webpack?-svgo,+titleProp,+ref!./DefaultPlayer.svg";
import { ReactComponent as LargePlayer } from "@svgr/webpack?-svgo,+titleProp,+ref!./LargePlayer.svg";
import { ReactComponent as Calendar } from "@svgr/webpack?-svgo,+titleProp,+ref!./Calendar.svg";
import { ReactComponent as Bell } from "@svgr/webpack?-svgo,+titleProp,+ref!./Bell.svg";
import { ReactComponent as YouTube } from "@svgr/webpack?-svgo,+titleProp,+ref!./YouTube.svg";
import { ReactComponent as SoundCloud } from "@svgr/webpack?-svgo,+titleProp,+ref!./SoundCloud.svg";
import { ReactComponent as Spotify } from "@svgr/webpack?-svgo,+titleProp,+ref!./Spotify.svg";
import { ReactComponent as Twitter } from "@svgr/webpack?-svgo,+titleProp,+ref!./Twitter.svg";
import { ReactComponent as Facebook } from "@svgr/webpack?-svgo,+titleProp,+ref!./Facebook.svg";
import { ReactComponent as Instagram } from "@svgr/webpack?-svgo,+titleProp,+ref!./Instagram.svg";
import { ReactComponent as Snapchat } from "@svgr/webpack?-svgo,+titleProp,+ref!./Snapchat.svg";
import { ReactComponent as Pandora } from "@svgr/webpack?-svgo,+titleProp,+ref!./Pandora.svg";
import { ReactComponent as Radio } from "@svgr/webpack?-svgo,+titleProp,+ref!./Radio.svg";
import { ReactComponent as Share } from "@svgr/webpack?-svgo,+titleProp,+ref!./Share.svg";
export const StandAloneIcons = {
  Add,
  Camera,
  Clipboard,
  Collapse,
  Delete,
  Description,
  Down,
  Download,
  Duplicate,
  Edit,
  Email,
  Exit,
  Expand,
  Export,
  Filter,
  Gallery,
  Gear,
  Hide,
  Import,
  Left,
  Link,
  Lock,
  Map,
  Next,
  Pencil,
  Previous,
  Refresh,
  Report,
  Right,
  Search,
  Send,
  Show,
  Shuffle,
  Subtract,
  Undo,
  Unlock,
  Up,
  Update,
  Upload,
  Video,
  DefaultPlayer,
  LargePlayer,
  Calendar,
  Bell,
  YouTube,
  SoundCloud,
  Spotify,
  Twitter,
  Facebook,
  Instagram,
  Snapchat,
  Pandora,
  Radio,
  Share
};
export const StandAloneIconNames = ["Add", "Camera", "Clipboard", "Collapse", "Delete", "Description", "Down", "Download", "Duplicate", "Edit", "Email", "Exit", "Expand", "Export", "Filter", "Gallery", "Gear", "Hide", "Import", "Left", "Link", "Lock", "Map", "Next", "Pencil", "Previous", "Refresh", "Report", "Right", "Search", "Send", "Show", "Shuffle", "Subtract", "Undo", "Unlock", "Up", "Update", "Upload", "Video", "DefaultPlayer", "LargePlayer", "Calendar", "Bell", "YouTube", "SoundCloud", "Spotify", "Twitter", "Facebook", "Instagram", "Snapchat", "Pandora", "Radio", "Share"];